import { reactive } from 'vue';

// Mirrors the design's say() helper: one toast, replaced on each call.
export const toastState = reactive({ message: '', visible: false });
let timer = null;

export function showToast(message) {
    toastState.message = message;
    toastState.visible = true;
    clearTimeout(timer);
    timer = setTimeout(() => { toastState.visible = false; }, 2600);
}

export function copyText(text, element) {
    const fallback = () => {
        if (element) {
            const range = document.createRange();
            range.selectNodeContents(element);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
        }
        showToast('Selected. Press copy on your keyboard.');
    };
    try {
        navigator.clipboard.writeText(text).then(() => showToast('Copied ' + text), fallback);
    } catch (e) {
        fallback();
    }
}
